//Generated File 
export const CRITERIA = `criteria`;
export const CRITERIA_REPLACE_STR = `[criteria]`;
export const DB_DEFAULT = `dbdefault`;
export const DECIMAL_NUMBER_REGEX = `[\.0-9]`;
export const DEFAULT = `default`;
export const DELETE = `delete`;
export const DIMENSION_NULL_ARABIC_CODE = `عام`;
export const DIMENSION_NULL_CODE = `PUBLIC`;
export const DOT_REGEX = `\.`;
export const FreeLineStyle = `dataGridFreeLine`;
export const ID_SANITIZER_REGEX = `[^A-Za-z0-9\\\/]`;
export const ID_SANITIZER_REGEX_WITHOUT_DOT = `[^\.A-Za-z0-9\\\/]`;
export const INSERTION_COUNT = `insertionCuont`;
export const InvalidSentLineStyle = `dataGridInvalidSentRow`;
export const LAYOUT_PREFERENCES_PATH = `/preferences/users/{0}/{1}/{2}`;
export const LAYOUT_PREFERENCES_PATH_PREFIX = `/preferences/users/`;
export const LAYOUT_PROCESSED_PATH = `/preferences/layouts/processed/{0}/{1}`;
export const LAYOUT_UNPROCESSED_PATH = `/preferences/layouts/{0}/{1}`;
export const LAYOUT_UNPROESSED_ROOT_FOLDER = `/preferences/layouts/{0}`;
export const LeafItemStyle = `dataGridL1Row`;
export const MARKER_END = `]`;
export const MARKER_START = `[`;
export const MAX_STRING = `ييييييييييييييييييييييي`;
export const MiddleItemStyle = `dataGridL2Row`;
export const NAMA_ROW_BACKGROUND_COLOR = `namaRowBackgroundColor`;
export const NAMA_STYLE_FIELDID = `namaStyle`;
export const ORDER = `order`;
export const ORDER_BY_REPLACE_STR = `[order]`;
export const ParentItemStyle = `dataGridL3Row`;
export const REGEX_OR = `|`;
export const ROW_BACKGROUND_COLOR = `rowBackgroundColor`;
export const ReturnedItemStyle = `dataGridReturnedRow`;
export const SELECTOR = `selector`;
export const SLASH = `/`;
export const SentLineStyle = `dataGridSentRow`;
export const SlaveLineStyle = `dataGridSlaveLine`;
export const TermConfigScreen = `TermConfigScreen`;
export const _id = `_id`;
export const dateFormat = `dd-MM-yyyy`;
export const dateTimeFormat = `yyyy-MM-dd'T'HH:mm:sss.SSS`;
export const editableDateTimeFormat = `yyyy-MM-dd HH:mm`;
export const editableTimeFormat = `HH:mm`;
export const legacyUIExtraStyles = `legacyUIExtraStyles`;
export const listViewTimeFormat = `HH:mm:ss`;
export const timeFormat = `hh:mm:ss aaa`;
